import React, { useState, useEffect, useRef } from 'react'
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import Loader from "../../../../Components/UiComponents/Loader";
import _ from 'lodash';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { loadFor } from '../../../../Services/checklistService';
import { loadFor as loadForTool } from '../../../../Services/toolService';
import { findSaved, saveBidteam } from '../../../../Services/bidteamService';
import CheckboxElement from '../../../../Components/UiComponents/CheckboxElement';
import DataTable from '../../../../Components/UiComponents/DataTable';
import { loadFor as loadForOpp } from '../../../../Services/opportunityService';
import InputTextElementElement from '../../../../Components/UiComponents/InputTextElement';
import ButtonElement from '../../../../Components/UiComponents/ButtonElement';
import { Tooltip } from 'primereact/tooltip';
import SingleSelectElement from '../../../../Components/UiComponents/SingleSelectElement';
import { getCustomerDetails } from '../../../../Services/clientService';
import CalendarElement from '../../../../Components/UiComponents/CalendarElement';
import { Dialog } from 'primereact/dialog';
import { reviewActionComplete, midReviewActionComplete } from '../../../../Services/opportunityService';
import Moment from "moment";
import { useOpportunity } from '../../../../Providers/OpportunityContext';
import socket from '../../../../socket';
import { clearCompletedNotification } from '../../../../Services/notificationService';
import { useNavigate } from 'react-router-dom';
import DropdownElement from '../../../../Components/UiComponents/DropdownElement';
import PlaylistVideos from '../../../../Components/Videos/PlaylistVideos';

const ReviewAndGovernance = (props) => {
	const [newModule, setNewModule] = useState({});
	const [loading, setLoading] = useState(false);
	const [opportunityData, setOpportunityData] = useState({});
	const [reviewChklist, setReviewChklist] = useState([]);
	const [reviewTools, setReviewTools] = useState([]);
	const [selectedOption, setSelectedOption] = useState([]);
	const [tooltipElem, setTooltipElem] = useState();
	const [reviewHead, setReviewHead] = useState([]);
	const [bidReviewHead, setBidReviewHead] = useState([]);
	const [midRecommendedActions, setMidRecommendedActions] = useState([]);
	const [recommendedActions, setRecommendedActions] = useState([]);
	const [winWorkStage, setWinWorkStage] = useState([]);
	const [selectedRevHead, setSelectedRevHead] = useState('');
	const [selectedReview, setSelectedReview] = useState('');
	const [revAction, setRevAction] = useState([]);
	const [selectedMidRevHead, setSelectedMidRevHead] = useState('');
	const [selectedMidReview, setSelectedMidReview] = useState([]);
	const [midRevAction, setMidRevAction] = useState([]);
	const [reviewManagementCompletedModal, setReviewManagementCompletedModal] = useState(false);
	const [midReviewManagementCompletedModal, setMidReviewManagementCompletedModal] = useState(false);
	const [isUserActionOwnerSameReview, setIsUserActionOwnerSameReview] = useState(false);
	const [rheadFlag, setrheadFlag] = useState(false);
	const [reviewData, setReviewData] = useState({});
	const [approvals, setApprovals] = useState([]);
	const [filteredApprovals, setFilteredApprovals] = useState([]);
	const [reviewAccess, setReviewAccess] = useState(false);
	const [individualScore, setIndividualScore] = useState([]);
	const [completedState, setCompletedState] = useState(false);
	const [completedMidState, setCompletedMidState] = useState(false);
	const [showVideo, setShowVideo] = useState(false);
	const { globalOpportunityData, setGlobalOpportunityData } = useOpportunity();
	const navigate = useNavigate()

	const enduser = localStorage.getItem("enduser");
	if (enduser) {
		var tmpData = JSON.parse(enduser);
		if (tmpData === null) {
			navigate("/login")
			localStorage.clear()
		}
	}

	const userId = tmpData.userid;
	const curCustomer = tmpData.customer;
	const role = tmpData.role;

	const userprivileges = localStorage.getItem("user_privileges");
	if (userprivileges) {
		var user_privileges = JSON.parse(userprivileges);
		if (user_privileges !== undefined && user_privileges !== null) {
			var checklist_prompts_access = user_privileges[0].checklist_prompts_access;
			var gateClosePrivilege = user_privileges[0].gate_closer;
		}
	}

	const toastRef = useRef();

	useEffect(() => {
		if (props.fieldData.pipelineReviewSections) {
			let obj1 = _.find(props?.fieldData?.pipelineReviewSections, { section_name: "Approvals" })?.display_name;

			let tooltipElement
			let obj2
			if (props.midStage) {
				obj2 = _.find(props?.fieldData?.pipelineReviewSections, { section_name: "Mid-Bid Review" })?.display_name;
				tooltipElement = props.customerTooltipDataOthers?.review['mid-bid_review'].status ? (
					<div>
						<Tooltip target=".custom-target-icon" />
						<i className="custom-target-icon pi pi-info-circle tooltip-font"
							data-pr-tooltip={props.customerTooltipDataOthers?.review['mid-bid_review'].text}
							data-pr-position="right">
						</i>
					</div>
				) : '';
			} else {
				obj2 = _.find(props?.fieldData?.pipelineReviewSections, { section_name: "Review Heading" })?.display_name;
				tooltipElement = props.customerTooltipDataOthers?.review.review_heading.status ? (
					<div>
						<Tooltip target=".custom-target-icon" />
						<i className="custom-target-icon pi pi-info-circle tooltip-font"
							data-pr-tooltip={props.customerTooltipDataOthers?.review.review_heading.text}
							data-pr-position="right">
						</i>
					</div>
				) : '';
			}

			let obj3 = _.find(props?.fieldData?.pipelineReviewSections, { section_name: "Checklist" })?.display_name;
			let obj4 = _.find(props?.fieldData?.pipelineReviewSections, { section_name: "Responsibilities" })?.display_name;
			let obj5 = _.find(props?.fieldData?.pipelineReviewSections, { section_name: "Review Prompts" })?.display_name;
			let obj6 = _.find(props?.fieldData?.pipelineReviewSections, { section_name: "Document Reference" })?.display_name;
			let combined = { obj1, obj2, obj3, obj4, obj5, obj6 };
			setTooltipElem(tooltipElement)
			setNewModule(combined)
		}
	}, [props.fieldData.pipelineReviewSections])

	useEffect(() => {
		if (props.opportunityData) {
			setOpportunityData(props.opportunityData)
			reviewLoad(props.opportunityData)
		}
	}, [props.opportunityData])

	useEffect(() => {
		if (completedState) {
			const index = reviewData.index;

			setRevAction((prevState) => {
				const updatedRevAction = [...prevState];

				updatedRevAction[index] = {
					...updatedRevAction[index],
					is_completed: false,
				};

				return updatedRevAction;
			});
			setCompletedState(false)
		}
	}, [completedState])

	useEffect(() => {
		if (completedMidState) {
			const index = reviewData.index;

			setMidRevAction((prevState) => {
				const updatedRevAction = [...prevState];

				updatedRevAction[index] = {
					...updatedRevAction[index],
					is_completed: false,
				};

				return updatedRevAction;
			});
			setCompletedMidState(false);
		}
	}, [completedMidState])

	useEffect(() => {
		const temp = approvals.filter((item) => {
			// Optimize filtering by combining checks and avoiding unnecessary nesting
			if (
				opportunityData.opportunity_type &&
 				item.check_project_type?.trim()?.toLowerCase()?.replaceAll(' ', '') !== '--pleaseselect--' &&
 				item.check_project_type?.trim() !== 'All' &&
				item.check_project_type?.trim() !== opportunityData.opportunity_type?.trim() 
			) {
				return false;
			}
			if (opportunityData.business_unit &&
 				item.business_unit?.trim()?.toLowerCase()?.replaceAll(' ', '') !== '--pleaseselect--' &&
				item.business_unit?.trim() !== 'All' &&
				item.business_unit?.trim() !== opportunityData.business_unit?.trim()) {
				return false;
			}
			if (opportunityData?.additional?.region &&
 				item.region?.trim()?.toLowerCase()?.replaceAll(' ', '') !== '--pleaseselect--' &&
				item.region?.trim() !== 'All' &&
				item.region?.trim() !== opportunityData.additional.region?.trim()) {
				return false;
			}
			return true;
		})
		setFilteredApprovals(temp);
	}, [approvals, opportunityData])

	useEffect(() => {
		if (props.individualScore.length > 0) {
			setIndividualScore(props.individualScore)
		}
	}, [props.individualScore])

	useEffect(() => {
		if (props?.customerId) {
			getCustomerDetail();
		}
	}, [props?.customerId]);

	useEffect(() => {
		setGlobalOpportunityData((prevData) => ({
			...prevData,
			reviews: {
				...prevData.reviews,
				completed_list: opportunityData.reviews?.completed_list
			}
		}));
	}, [opportunityData.reviews]);

	useEffect(() => {
		if (revAction.length > 0 && selectedRevHead != '') {
			setGlobalOpportunityData((prevData) => {
				// Find if the selectedRevHead already exists in reviews_head
				const existingReview = prevData.reviews_head?.find(
					(review) => review.reviews_head_name === selectedRevHead
				);

				if (existingReview) {
					// Update the review_check_list for the existing selectedRevHead
					return {
						...prevData,
						reviews_head: prevData.reviews_head?.map((review) =>
							review.reviews_head_name === selectedRevHead
								? { ...review, review_check_list: revAction }
								: review
						),
					};
				} else {
					// Add new selectedRevHead and review_check_list
					return {
						...prevData,
						reviews_head: [
							...prevData.reviews_head,
							{
								reviews_head_name: selectedRevHead,
								review_check_list: revAction,
							},
						],
					};
				}
			});
		}
	}, [revAction, selectedRevHead]);

	useEffect(() => {
		if (midRevAction.length > 0 && selectedMidRevHead != '') {
			setGlobalOpportunityData((prevData) => {
				// Find if the selectedMidRevHead already exists in reviews_head
				const existingReview = prevData.mid_reviews_head.find(
					(review) => review.reviews_head_name === selectedMidRevHead
				);

				if (existingReview) {
					// Update the review_check_list for the existing selectedMidRevHead
					return {
						...prevData,
						mid_reviews_head: prevData.mid_reviews_head.map((review) =>
							review.reviews_head_name === selectedMidRevHead
								? { ...review, review_check_list: midRevAction }
								: review
						),
					};
				} else {
					// Add new selectedMidRevHead and review_check_list
					return {
						...prevData,
						mid_reviews_head: [
							...prevData.mid_reviews_head,
							{
								reviews_head_name: selectedMidRevHead,
								review_check_list: midRevAction,
							},
						],
					};
				}
			});
		}
	}, [midRevAction, selectedMidRevHead]);

	// useEffect(() => {
	// 	setGlobalOpportunityData((prevData) => ({
	// 		...prevData,
	// 		approvals: opportunityData.approvals
	// 	}));
	// }, [opportunityData.approvals]);

	// useEffect(() => {
	// 	setGlobalOpportunityData((prevData) => ({
	// 		...prevData,
	// 		gateways: opportunityData.gateways
	// 	}));
	// }, [opportunityData.gateways]);

	// useEffect(() => {
	// 	setGlobalOpportunityData((prevData) => ({
	// 		...prevData,
	// 		winwork_stage: opportunityData.winwork_stage
	// 	}));
	// }, [opportunityData.winwork_stage]);

	const getCustomerDetail = async () => {
		try {
			setLoading(true)
			const response = await getCustomerDetails(props?.customerId);
			setLoading(false)
			const updatedClient = [];
			const bidReviewHead = [];
			const midRecommendedActions = [];
			const recommendedActions = [];
			const winWorkStage = [];

			if (response.data?.reference_data) {
				const cusData = response.data?.reference_data;
				cusData?.forEach((item) => {
					const activeChoices = _.filter(item.option_choice, { status: 'active' });
					switch (item.option_names) {
						case "WinWorkStage":
							winWorkStage.push(activeChoices?.map(element => ({
								id: element._id,
								label: element.label,
								status: element.status,
								text: element.text
							})));
							break;
						case "GWTarget":
							updatedClient[0] = activeChoices?.map(element => ({
								id: element._id,
								label: element.label,
								status: element.status,
							}));
							break;
						case "GWPursuit":
							updatedClient[1] = activeChoices?.map(element => ({
								id: element._id,
								label: element.label,
								status: element.status,
							}));
							break;
						case "GWPrequalify":
							updatedClient[2] = activeChoices?.map(element => ({
								id: element._id,
								label: element.label,
								status: element.status,
							}));
							break;
						case "GWSubmission":
							updatedClient[3] = activeChoices?.map(element => ({
								id: element._id,
								label: element.label,
								status: element.status,
							}));
							break;
						case "GWAppointment":
							updatedClient[4] = activeChoices?.map(element => ({
								id: element._id,
								label: element.label,
								status: element.status,
							}));
							break;
						case "GWDeliver":
							updatedClient[5] = activeChoices?.map(element => ({
								id: element._id,
								label: element.label,
								status: element.status,
							}));
							break;
						case "GWFeedback":
							updatedClient[6] = activeChoices?.map(element => ({
								id: element._id,
								label: element.label,
								status: element.status,
							}));
							break;
						case "GWMSubmission":
							bidReviewHead[0] = activeChoices?.map(element => ({
								id: element._id,
								label: element.label,
								status: element.status,
							}));
							break;
						case "GWMDeliver":
							bidReviewHead[1] = activeChoices?.map(element => ({
								id: element._id,
								label: element.label,
								status: element.status,
							}));
							break;
						case "ICMidSubmissionInternalCommunications":
							midRecommendedActions[0] = activeChoices?.map(element => ({
								id: element._id,
								label: element.label,
								status: element.status,
							}));
							break;
						case "ICMidDeliverInternalCommunications":
							midRecommendedActions[1] = activeChoices?.map(element => ({
								id: element._id,
								label: element.label,
								status: element.status,
							}));
							break;
						case "ICTargetInternalCommunications":
							recommendedActions[0] = activeChoices?.map(element => ({
								id: element._id,
								label: element.label,
								status: element.status,
							}));
							break;
						case "ICPursuitInternalCommunications":
							recommendedActions[1] = activeChoices?.map(element => ({
								id: element._id,
								label: element.label,
								status: element.status,
							}));
							break;
						case "ICPrequalifyInternalCommunications":
							recommendedActions[2] = activeChoices?.map(element => ({
								id: element._id,
								label: element.label,
								status: element.status,
							}));
							break;
						case "ICSubmissionInternalCommunications":
							recommendedActions[3] = activeChoices?.map(element => ({
								id: element._id,
								label: element.label,
								status: element.status,
							}));
							break;
						case "ICAppointmentInternalCommunications":
							recommendedActions[4] = activeChoices?.map(element => ({
								id: element._id,
								label: element.label,
								status: element.status,
							}));
							break;
						case "ICDeliverInternalCommunications":
							recommendedActions[5] = activeChoices?.map(element => ({
								id: element._id,
								label: element.label,
								status: element.status,
							}));
							break;
						case "ICFeedbackInternalCommunications":
							recommendedActions[6] = activeChoices?.map(element => ({
								id: element._id,
								label: element.label,
								status: element.status,
							}));
							break;
						default:
							break;
					}
				})
				setReviewHead(updatedClient);
				setBidReviewHead(bidReviewHead)
				setMidRecommendedActions(midRecommendedActions)
				setRecommendedActions(recommendedActions)
				setWinWorkStage(winWorkStage)
			}

		} catch (error) {
			console.error(error);
		}
	};

	const reviewLoad = async (opportunityDetails) => {
		try {
			var stage = ""
			if (opportunityDetails.winwork_stage == "Target" || opportunityDetails.winwork_stage == "Pursuit") {
				stage = "BD";
			} else if (opportunityDetails.winwork_stage == "Pre-Qualify") {
				stage = "PQQ";
			} else {
				stage = "ITT";
			}

			//approvals load
			var approvals = [];
			//Accountable check and push
			var reviewAccess = false;
			var pendingResponsibilities = []
			var bidTeam = opportunityDetails.ie_bid_team?.internal_bid_team;

			if (checklist_prompts_access) {
				for (var x = 0; x < bidTeam?.length; x++) {
					if (bidTeam[x].user_id == userId) {
						reviewAccess = true;
					}
				}
			}
			setReviewAccess(reviewAccess)
			if (opportunityDetails?.approvals?.length > 0) {
				approvals = opportunityDetails?.approvals;
			}

			//checklist approvals
			var checkdata = await loadFor(curCustomer, opportunityDetails.winwork_stage, "Review", opportunityDetails.sector)

			if (checkdata.data.length > 0) {
				var appLen = approvals.length;

				for (var i = 0; i < checkdata.data.length; i++) {
					var isRAC = false;
					if (reviewAccess == true) {
						var findUserBidRole = _.find(bidTeam, { user_id: userId, });
						var bidTeamRole = findUserBidRole?.bid_team_role;
						var contributing_users = checkdata.data[i].contributing_users.filter(user => user.role === bidTeamRole);
						var responsible_users = checkdata.data[i].responsible_users.filter(user => user.role === bidTeamRole);

						var accountable_users = !_.isEmpty(checkdata.data[i].accountable_users) ? checkdata.data[i].accountable_users["role"] : "";
						if (!_.isEmpty(responsible_users) || accountable_users == bidTeamRole) {
							isRAC = true;
						}
						if (appLen > 0) {
							var newItem = true;
							for (var x = 0; x < appLen; x++) {
								if (approvals[x].item_id == checkdata.data[i]._id && approvals[x].substage == checkdata.data[i].winstage) {
									approvals[x]["check_project_type"] = checkdata.data[i].opportunity_type;
									approvals[x]["business_unit"] = checkdata.data[i].business_unit;
									approvals[x]["checklist_type"] = checkdata.data[i].checklist_type;
									approvals[x]["region"] = checkdata.data[i].region;
									approvals[x]["sector"] = checkdata.data[i].sector;
									approvals[x]["winstage"] = checkdata.data[i].winstage;
									approvals[x]["winwork_display"] = checkdata.data[i].winwork_display;
									approvals[x]["branch"] = checkdata.data[i].branch;
									newItem = false;
								}
								if ((approvals[x].approved == undefined || approvals[x].approved == false) && approvals[x].item_id == checkdata.data[i]._id) {
									approvals[x].isRACI = isRAC;
								}
							}
							if (newItem == true) {
								approvals.push({
									item: checkdata.data[i].checklist_item,
									item_id: checkdata.data[i]._id,
									stage: stage,
									substage: opportunityDetails.winwork_stage,
									role: checkdata.data[i].accountable_users.role,
									active: true,
									check_project_type: checkdata.data[i].opportunity_type,
									business_unit: checkdata.data[i].business_unit,
									checklist_type: checkdata.data[i].checklist_type,
									region: checkdata.data[i].region,
									sector: checkdata.data[i].sector,
									winstage: checkdata.data[i].winstage,
									winwork_display: checkdata.data[i].winwork_display,
									branch: checkdata.data[i].branch,
									approved: false,
									isRACI: isRAC,
								});
								setApprovals(approvals)
							}
						} else {
							approvals.push({
								item: checkdata.data[i].checklist_item,
								item_id: checkdata.data[i]._id,
								stage: stage,
								substage: opportunityDetails.winwork_stage,
								active: true,
								check_project_type: checkdata.data[i].opportunity_type,
								business_unit: checkdata.data[i].business_unit,
								checklist_type: checkdata.data[i].checklist_type,
								region: checkdata.data[i].region,
								sector: checkdata.data[i].sector,
								winstage: checkdata.data[i].winstage,
								winwork_display: checkdata.data[i].winwork_display,
								branch: checkdata.data[i].branch,
								role: checkdata.data[i].accountable_users.role,
								approved: false,
								isRACI: isRAC,
							});
							setApprovals(approvals)
						}
					} else {
						if (appLen > 0) {
							var newItem = true;
							for (var x = 0; x < appLen; x++) {
								if (approvals[x].item_id == checkdata.data[i]._id && approvals[x].substage == checkdata.data[i].winstage) {
									approvals[x]["check_project_type"] = checkdata.data[i].opportunity_type;
									approvals[x]["business_unit"] = checkdata.data[i].business_unit;
									approvals[x]["checklist_type"] = checkdata.data[i].checklist_type;
									approvals[x]["region"] = checkdata.data[i].region;
									approvals[x]["sector"] = checkdata.data[i].sector;
									approvals[x]["winstage"] = checkdata.data[i].winstage;
									approvals[x]["winwork_display"] = checkdata.data[i].winwork_display;
									approvals[x]["branch"] = checkdata.data[i].branch;
									newItem = false;
								}
								if (approvals[x].approved == false && approvals[x].item_id == checkdata.data[i]._id) {
									approvals[x].isRACI = isRAC;
								}
							}
							if (newItem == true) {
								approvals.push({
									item: checkdata.data[i].checklist_item,
									item_id: checkdata.data[i]._id,
									active: true,
									check_project_type: checkdata.data[i].opportunity_type,
									business_unit: checkdata.data[i].business_unit,
									checklist_type: checkdata.data[i].checklist_type,
									region: checkdata.data[i].region,
									sector: checkdata.data[i].sector,
									winstage: checkdata.data[i].winstage,
									winwork_display: checkdata.data[i].winwork_display,
									branch: checkdata.data[i].branch,
									stage: stage,
									substage: opportunityDetails.winwork_stage,
									access: false,
									isRACI: isRAC,
								});
								setApprovals(approvals)
							}
						} else {
							approvals.push({
								item: checkdata.data[i].checklist_item,
								item_id: checkdata.data[i]._id,
								stage: stage,
								active: true,
								check_project_type: checkdata.data[i].opportunity_type,
								business_unit: checkdata.data[i].business_unit,
								checklist_type: checkdata.data[i].checklist_type,
								region: checkdata.data[i].region,
								sector: checkdata.data[i].sector,
								winstage: checkdata.data[i].winstage,
								winwork_display: checkdata.data[i].winwork_display,
								branch: checkdata.data[i].branch,
								substage: opportunityDetails.winwork_stage,
								access: false,
								isRACI: isRAC,
							});
							setApprovals(approvals)
						}
					}
				}
			}

			//tools approval
			var toolData = await loadForTool(curCustomer, opportunityDetails.winwork_stage, "Review", opportunityDetails.sector)

			if (toolData.data.length > 0) {
				var appLen = approvals.length;
				for (var i = 0; i < toolData.data.length; i++) {
					var isRAC = false;
					if (reviewAccess == true) {
						var findUserBidRole = _.find(bidTeam, { user_id: userId, });
						var bidTeamRole = findUserBidRole?.bid_team_role;
						var contributing_users = toolData.data[i].contributing_users.filter(user => user.role === bidTeamRole);
						var responsible_users = toolData.data[i].responsible_users.filter(user => user.role === bidTeamRole);

						var accountable_users = !_.isEmpty(toolData.data[i].accountable_users) ? toolData.data[i].accountable_users["role"] : "";

						if (!_.isEmpty(responsible_users) || accountable_users == bidTeamRole) {
							isRAC = true;
						}
						if (appLen > 0) {
							var newItem = true;
							for (var x = 0; x < appLen; x++) {
								if (approvals[x].item_id == toolData.data[i]._id && approvals[x].substage == toolData.data[i].winstage) {
									newItem = false;
								}
								if ((approvals[x].approved == undefined || approvals[x].approved == false) && approvals[x].item_id == toolData.data[i]._id) {
									approvals[x].isRACI = isRAC;
								}
							}
							if (newItem == true) {
								approvals.push({
									item: toolData.data[i].display_name,
									item_id: toolData.data[i]._id,
									stage: stage,
									substage: opportunityDetails.winwork_stage,
									role: toolData.data[i].accountable_users.role,
									approved: false,
									isRACI: isRAC,
								});
								setApprovals(approvals)
							}
						} else {
							approvals.push({
								item: toolData.data[i].display_name,
								item_id: toolData.data[i]._id,
								stage: stage,
								substage: opportunityDetails.winwork_stage,
								role: toolData.data[i].accountable_users.role,
								approved: false,
								isRACI: isRAC,
							});
							setApprovals(approvals)
						}
					} else {
						if (appLen > 0) {
							var newItem = true;
							for (var x = 0; x < appLen; x++) {
								if (approvals[x].item_id == toolData.data[i]._id && approvals[x].substage == toolData.data[i].winstage) {
									newItem = false;
								}
								if (approvals[x].approved == false && approvals[x].item_id == toolData.data[i]._id) {
									approvals[x].isRACI = isRAC;
								}
							}
							if (newItem == true) {
								approvals.push({
									item: toolData.data[i].display_name,
									item_id: toolData.data[i]._id,
									stage: stage,
									substage: opportunityDetails.winwork_stage,
									access: false,
									isRACI: isRAC,
								});
								setApprovals(approvals)
							}
						} else {
							approvals.push({
								item: toolData.data[i].display_name,
								item_id: toolData.data[i]._id,
								stage: stage,
								substage: opportunityDetails.winwork_stage,
								access: false,
								isRACI: isRAC,
							});
							setApprovals(approvals)
						}
					}
				}

				var prevStages = loadForOpp(curCustomer, opportunityDetails._id)

				if (prevStages.data) {
					var previousStages = prevStages.data
					// Filter approvals based on matching properties and values
					approvals = approvals.filter(approval => {
						const prevStage = previousStages.find(prev => prev.winwork_display === approval.winwork_display);
						if (approval.check_project_type == 'All') {
							return true
						}
						if (prevStage && prevStage.services === approval.check_project_type && prevStage.winwork_display === approval.winwork_display) {
							return true;
						}
						return false;
					});

				}
			}

			var checkeddata = await loadFor(curCustomer, opportunityDetails.winwork_stage, "Review", opportunityDetails.sector)

			if (checkeddata?.data && checkeddata.data.length > 0) {
				var findUserBidRole = _.find(bidTeam, { user_id: userId });
				var bidTeamRole = findUserBidRole?.bid_team_role;

				var resultBid = await findSaved(curCustomer, bidTeamRole, opportunityDetails._id, opportunityDetails.winwork_stage)
				var data = resultBid.data.data;
				var reviewChklist = [];

				if (reviewAccess == true) {
					if (data && data.review.checklist) {
						if (data.review.checklist.length > 0) {
							if (resultBid?.data.bid_team_role == bidTeamRole) {
								for (var i = 0; i < checkeddata.data.length; i++) {
									var informed_users = checkeddata.data[i].informed_users;
									var contributing_users = checkeddata.data[i].contributing_users;
									var accountable_users = checkeddata.data[i].accountable_users;
									var responsible_users = checkeddata.data[i].responsible_users;
									for (var j = 0; j < informed_users.length; j++) {
										if (bidTeamRole == informed_users[j].role) {
											var status = false;
											for (var y = 0; y < data.review.checklist.length; y++) {
												if (data.review.checklist[y].check == checkeddata.data[i].checklist_item + " (I)" && data.review.checklist[y].status) {
													status = true;
													break;
												}
											}
											reviewChklist.push({
												check: checkeddata.data[i].checklist_item + " (I)",
												status: status,
											});
										}
									}
									for (var j = 0; j < contributing_users.length; j++) {
										if (bidTeamRole == contributing_users[j].role) {
											var status = false;
											for (var y = 0; y < data.review.checklist.length; y++) {
												if (data.review.checklist[y].check == checkeddata.data[i].checklist_item + " (C)" && data.review.checklist[y].status) {
													status = true;
													break;
												}
											}
											reviewChklist.push({
												check: checkeddata.data[i].checklist_item + " (C)",
												status: status,
											});
										}
									}
									if (accountable_users != null) {
										if (bidTeamRole == accountable_users.role) {
											var status = false;
											for (var y = 0; y < data.review.checklist.length; y++) {
												if (data.review.checklist[y].check == checkeddata.data[i].checklist_item + " (A)" && data.review.checklist[y].status) {
													status = true;
													break;
												}
											}
											reviewChklist.push({
												check: checkeddata.data[i].checklist_item + " (A)",
												status: status,
											});
										}
									}
									for (var j = 0; j < responsible_users.length; j++) {
										if (bidTeamRole == responsible_users[j].role) {
											var status = false;
											for (var y = 0; y < data.review.checklist.length; y++) {
												if (data.review.checklist[y].check == checkeddata.data[i].checklist_item + " (R)" && data.review.checklist[y].status) {
													status = true;
													break;
												}
											}
											reviewChklist.push({
												check: checkeddata.data[i].checklist_item + " (R)",
												status: status,
											});
										}
									}
								}
							}
						} else {
							for (var i = 0; i < checkeddata.data.length; i++) {
								var informed_users = checkeddata.data[i].informed_users;
								var contributing_users = checkeddata.data[i].contributing_users;
								var accountable_users = checkeddata.data[i].accountable_users;
								var responsible_users = checkeddata.data[i].responsible_users;

								for (var j = 0; j < informed_users.length; j++) {
									if (bidTeamRole == informed_users[j].role) {
										reviewChklist.push({
											check: checkeddata.data[i].checklist_item + " (I)",
											status: false,
										});
									}
								}

								for (var j = 0; j < contributing_users.length; j++) {
									if (bidTeamRole == contributing_users[j].role) {
										reviewChklist.push({
											check: checkeddata.data[i].checklist_item + " (C)",
											status: false,
										});
									}
								}
								if (accountable_users != null) {
									if (bidTeamRole == accountable_users.role) {
										reviewChklist.push({
											check: checkeddata.data[i].checklist_item + " (A)",
											status: false,
										});
									}
								}
								for (var j = 0; j < responsible_users.length; j++) {
									if (bidTeamRole == responsible_users[j].role) {
										reviewChklist.push({
											check: checkeddata.data[i].checklist_item + " (R)",
											status: false,
										});
									}
								}
							}
						}
					} else {
						for (var i = 0; i < checkeddata.data.length; i++) {
							var informed_users = checkeddata.data[i].informed_users;
							var contributing_users = checkeddata.data[i].contributing_users;
							var accountable_users = checkeddata.data[i].accountable_users;
							var responsible_users = checkeddata.data[i].responsible_users;

							for (var j = 0; j < informed_users.length; j++) {
								if (bidTeamRole == informed_users[j].role) {
									reviewChklist.push({
										check: checkeddata.data[i].checklist_item + " (I)",
										status: false,
									});
								}
							}

							for (var j = 0; j < contributing_users.length; j++) {
								if (bidTeamRole == contributing_users[j].role) {
									reviewChklist.push({
										check: checkeddata.data[i].checklist_item + " (C)",
										status: false,
									});
								}
							}
							if (accountable_users != null) {
								if (bidTeamRole == accountable_users.role) {
									reviewChklist.push({
										check: checkeddata.data[i].checklist_item + " (A)",
										status: false,
									});
								}
							}

							for (var j = 0; j < responsible_users.length; j++) {
								if (bidTeamRole == responsible_users[j].role) {
									reviewChklist.push({
										check: checkeddata.data[i].checklist_item + " (R)",
										status: false,
									});
								}
							}
						}
					}
				}
				setReviewChklist(reviewChklist)
			}

			var toolReviewData = await loadForTool(curCustomer, opportunityDetails.winwork_stage, "Review", opportunityDetails.sector)

			if (toolReviewData.data.length > 0) {
				var findUserBidRole = _.find(bidTeam, { user_id: userId });
				var bidTeamRole = findUserBidRole?.bid_team_role;

				var resultReview = await findSaved(curCustomer, bidTeamRole, opportunityDetails._id, opportunityDetails.winwork_stage)
				var data = resultReview.data.data;
				var reviewTools = [];

				if (reviewAccess == true) {
					if (data && data.review.responsibility) {
						if (data.review.responsibility.length > 0) {
							if (resultReview?.data.bid_team_role == bidTeamRole) {
								for (var i = 0; i < toolReviewData.data.length; i++) {
									var informed_users = toolReviewData.data[i].informed_users;
									var contributing_users = toolReviewData.data[i].contributing_users;
									var accountable_users = toolReviewData.data[i].accountable_users;
									var responsible_users = toolReviewData.data[i].responsible_users;

									for (var j = 0; j < informed_users.length; j++) {
										if (bidTeamRole == informed_users[j].role) {
											var status = false;
											for (var y = 0; y < data.review.responsibility.length; y++) {
												if (data.review.responsibility[y].check == toolReviewData.data[i].display_name + " (I)" && data.review.responsibility[y].status) {
													status = true;
													break;
												}
											}
											reviewTools.push({
												check: toolReviewData.data[i].display_name + " (I)",
												status: status,
												url: toolReviewData.data[i].url,
											});
											if (status != true)
												pendingResponsibilities.push({
													resp: toolReviewData.data[i].display_name + " (I)",
												});
										}
									}
									for (var j = 0; j < contributing_users.length; j++) {
										if (bidTeamRole == contributing_users[j].role) {
											var status = false;
											for (var y = 0; y < data.review.responsibility.length; y++) {
												if (data.review.responsibility[y].check == toolReviewData.data[i].display_name + " (C)" && data.review.responsibility[y].status) {
													status = true;
													break;
												}
											}
											reviewTools.push({
												check: toolReviewData.data[i].display_name + " (C)",
												status: status,
												url: toolReviewData.data[i].url,
											});
											if (status != true)
												pendingResponsibilities.push({
													resp: toolReviewData.data[i].display_name + " (C)",
												});
										}
									}
									if (accountable_users != null) {
										if (bidTeamRole == accountable_users.role) {
											var status = false;
											for (var y = 0; y < data.review.responsibility.length; y++) {
												if (data.review.responsibility[y].check == toolReviewData.data[i].display_name + " (A)" && data.review.responsibility[y].status) {
													status = true;
													break;
												}
											}
											reviewTools.push({
												check: toolReviewData.data[i].display_name + " (A)",
												status: status,
												url: toolReviewData.data[i].url,
											});
											if (status != true)
												pendingResponsibilities.push({
													resp: toolReviewData.data[i].display_name + " (A)",
												});
										}
									}
									for (var j = 0; j < responsible_users.length; j++) {
										if (bidTeamRole == responsible_users[j].role) {
											var status = false;
											for (var y = 0; y < data.review.responsibility.length; y++) {
												if (data.review.responsibility[y].check == toolReviewData.data[i].display_name + " (R)" && data.review.responsibility[y].status) {
													status = true;
													break;
												}
											}
											reviewTools.push({
												check: toolReviewData.data[i].display_name + " (R)",
												status: status,
												url: toolReviewData.data[i].url,
											});
											if (status != true)
												pendingResponsibilities.push({
													resp: toolReviewData.data[i].display_name + " (R)",
												});
										}
									}
								}
							}
						} else {
							for (var i = 0; i < toolReviewData.data.length; i++) {
								var informed_users = toolReviewData.data[i].informed_users;
								var contributing_users = toolReviewData.data[i].contributing_users;
								var accountable_users = toolReviewData.data[i].accountable_users;
								var responsible_users = toolReviewData.data[i].responsible_users;

								for (var j = 0; j < informed_users.length; j++) {
									if (bidTeamRole == informed_users[j].role) {
										reviewTools.push({
											check: toolReviewData.data[i].display_name + " (I)",
											status: false,
											url: toolReviewData.data[i].url,
										});
										pendingResponsibilities.push({
											resp: toolReviewData.data[i].display_name,
										});
									}
								}

								for (var j = 0; j < contributing_users.length; j++) {
									if (bidTeamRole == contributing_users[j].role) {
										reviewTools.push({
											check: toolReviewData.data[i].display_name + " (C)",
											status: false,
											url: toolReviewData.data[i].url,
										});
										pendingResponsibilities.push({
											resp: toolReviewData.data[i].display_name,
										});
									}
								}
								if (accountable_users != null) {
									if (bidTeamRole == accountable_users.role) {
										reviewTools.push({
											check: toolReviewData.data[i].display_name + " (A)",
											status: false,
											url: toolReviewData.data[i].url,
										});
										pendingResponsibilities.push({
											resp: toolReviewData.data[i].display_name,
										});
									}
								}
								for (var j = 0; j < responsible_users.length; j++) {
									if (bidTeamRole == responsible_users[j].role) {
										reviewTools.push({
											check: toolReviewData.data[i].display_name + " (R)",
											status: false,
											url: toolReviewData.data[i].url,
										});
										pendingResponsibilities.push({
											resp: toolReviewData.data[i].display_name,
										});
									}
								}
							}
						}
						// if (data.review.reference == null) {
						// 	data.review.reference = [];
						// } else {
						// 	setOpportunityData((prevState) => ({
						// 		...prevState,
						// 		review: {
						// 			...prevState.review,
						// 			completed_list: data.review.reference
						// 		},
						// 	}));
						// }
					} else {
						for (var i = 0; i < toolReviewData.data.length; i++) {
							var informed_users = toolReviewData.data[i].informed_users;
							var contributing_users = toolReviewData.data[i].contributing_users;
							var accountable_users = toolReviewData.data[i].accountable_users;
							var responsible_users = toolReviewData.data[i].responsible_users;

							for (var j = 0; j < informed_users.length; j++) {
								if (bidTeamRole == informed_users[j].role) {
									reviewTools.push({
										check: toolReviewData.data[i].display_name + " (I)",
										status: false,
										url: toolReviewData.data[i].url,
									});
									pendingResponsibilities.push({
										resp: toolReviewData.data[i].display_name,
									});
								}
							}

							for (var j = 0; j < contributing_users.length; j++) {
								if (bidTeamRole == contributing_users[j].role) {
									reviewTools.push({
										check: toolReviewData.data[i].display_name + " (C)",
										status: false,
										url: toolReviewData.data[i].url,
									});
									pendingResponsibilities.push({
										resp: toolReviewData.data[i].display_name,
									});
								}
							}
							if (accountable_users != null) {
								if (bidTeamRole == accountable_users.role) {
									reviewTools.push({
										check: toolReviewData.data[i].display_name + " (A)",
										status: false,
										url: toolReviewData.data[i].url,
									});
									pendingResponsibilities.push({
										resp: toolReviewData.data[i].display_name,
									});
								}
							}

							for (var j = 0; j < responsible_users.length; j++) {
								if (bidTeamRole == responsible_users[j].role) {
									reviewTools.push({
										check: toolReviewData.data[i].display_name + " (R)",
										status: false,
										url: toolReviewData.data[i].url,
									});
									pendingResponsibilities.push({
										resp: toolReviewData.data[i].display_name,
									});
								}
							}
						}
					}
				}

				setReviewTools(reviewTools)
			}

			setOpportunityData((prevState) => ({
				...prevState,
				approvals: approvals
			}))
			setApprovals(approvals)
			props.pendingResponsibility(pendingResponsibilities)
		} catch (error) {
			// Handle any errors that occurred during the API calls
			// toastRef.current.showToast({
			// 	type: 'error',
			// 	message: 'An error occurred. Please try again or contact Admin.'
			// });
			console.log(error)
		}
	}

	const rev_check_change = async (e, index, field) => {
		try {
			var findUserBidRole = _.find(opportunityData.ie_bid_team.internal_bid_team, { user_id: userId });

			if (!_.isEmpty(findUserBidRole) && !_.isEmpty(findUserBidRole?.bid_team_role)) {
				var revChanges = {};
				revChanges.opportunity_id = opportunityData._id;
				revChanges.customer_id = curCustomer;
				revChanges.winstage = opportunityData.winwork_stage;
				revChanges.reviews = {};

				//checklist
				var checklist = [];
				for (var i = 0; i < reviewChklist.length; i++) {
					if (index == i) {
						reviewChklist[index].status = (field == 'checklist') ? e.checked : reviewChklist[index].status
					}
					checklist.push(reviewChklist[i]);
				}
				revChanges.reviews.checklist = checklist;

				//responsibility
				var responsibility = [];
				for (var i = 0; i < reviewTools.length; i++) {
					if (index == i) {
						reviewTools[index].status = (field == 'resp') ? e.checked : reviewTools[index].status
					}
					responsibility.push(reviewTools[i]);
				}
				revChanges.reviews.responsibility = responsibility;

				//reference
				var reference = [];
				for (var i = 0; i < opportunityData.reviews?.completed_list.length; i++) {
					reference.push(opportunityData.reviews?.completed_list[i]);
				}
				revChanges.reviews.reference = reference;
				revChanges.bid_team_role = findUserBidRole?.bid_team_role;

				var res = await saveBidteam(role, revChanges)
				reviewLoad(opportunityData)
			}
		} catch (error) {
			// Handle any errors that occurred during the API calls
			toastRef.current.showToast({
				type: 'error',
				message: 'An error occurred. Please try again or contact Admin.'
			});
		}
	}

	const statusTemplate = (rowData, ind) => {
		return (
			<CheckboxElement
				id={`check-${ind.rowIndex}`}
				name={`check-${ind.rowIndex}`}
				value={rowData.status}
				checked={rowData.status}
				onChangeCheck={(e) => rev_check_change(e, ind.rowIndex, 'checklist')}
				className="mr-2"
			/>
		)
	}

	const statusRespTemplate = (rowData, ind) => {
		return (
			<CheckboxElement
				id={`resp-${ind.rowIndex}`}
				name={`resp-${ind.rowIndex}`}
				value={rowData.status}
				checked={rowData.status}
				onChangeCheck={(e) => rev_check_change(e, ind.rowIndex, 'resp')}
				className="mr-2"
			/>
		)
	}

	const checkTemplate = (rowData) => {
		return (
			<a target="_blank" href={`${rowData.url}`}>{rowData.check}</a>
		)
	}

	const columns1 = [
		{ field: "check", header: _.find(props.fieldData.oppReviewsTable, { table_name: "Positioning to win checklist for the current stages" })?.display_name, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '80%' } },
		{ field: "status", header: "", body: statusTemplate, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '20%' } },
	]

	const columns2 = [
		{ field: "check", header: _.find(props.fieldData.oppReviewsTable, { table_name: "My Responsibilities" })?.display_name, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '80%' } },
		{ field: "status", header: "", body: statusRespTemplate, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '20%' } },
	]

	const columns3 = [
		{ field: "check", header: _.find(props.fieldData.oppReviewsTable, { table_name: "Review Prompts" })?.display_name, body: checkTemplate, headerClassName: "header-datatable", className: 'row-datatable' },
	]

	const [optionDocument, setOptionDocument] = useState([
		{ id: "", location: "", reference: "" },
	]);

	const onTextChangeDocumentName = (index, field) => (e) => {
		const newDocumentName = [...opportunityData?.reviews.completed_list];
		if (field === "reference") {
			newDocumentName[index][field] = e.target.value;
		} else {
			newDocumentName[index][field] = e.target.value;
		}

		setOpportunityData((prevState) => ({
			...prevState,
			reviews: {
				...prevState.reviews,
				completed_list: newDocumentName, // Directly set the updated array here
			},
		}));
	};

	const documentReferenceNameEditor = (row, index) => {
		return (
			<div className="flex align-items-center">
				<InputTextElementElement
					className="dropdown-field-handle"
					value={row.reference}
					placeholder="Description"
					onChange={onTextChangeDocumentName(index?.rowIndex, "reference")}
				/>
			</div>
		);
	};

	const documentReferenceLocationEditor = (row, index) => {
		return (
			<div className="flex align-items-center">
				<InputTextElementElement
					className="dropdown-field-handle"
					value={row.location}
					placeholder="Description"
					onChange={onTextChangeDocumentName(index?.rowIndex, "location")}
				/>
			</div>
		);
	};

	const columns = [
		{ field: "reference", header: _.find(props.fieldData.oppReviewsCompletedHeaders, { header_name: "Name" })?.display_name, body: documentReferenceNameEditor, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '30%' } },
		{ field: "location", header: _.find(props.fieldData.oppReviewsCompletedHeaders, { header_name: "Location Reference" })?.display_name, body: documentReferenceLocationEditor, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '70%' } },
	]

	const rowClick = async (data) => {
		setSelectedOption(data)
	};

	const generateRandomID = () => {
		const hexChars = '0123456789abcdef';
		let result = '';
		for (let i = 0; i < 24; i++) {
			result += hexChars.charAt(Math.floor(Math.random() * hexChars.length));
		}
		return result;
	}

	const addItemDocument = () => {
		const newRow = {
			_id: generateRandomID(),
			reference: "",
			location: ""

		};
		setOptionDocument([...optionDocument, newRow]);
		setOpportunityData((prevState) => ({
			...prevState,
			['reviews']: {
				...prevState['reviews'],
				['completed_list']: [
					...prevState['reviews']['completed_list'],
					newRow
				],
			},
		}));
	};

	const handleDeleteDocument = () => {
		const updatedOptions = opportunityData.reviews?.completed_list.filter(
			(row) => !selectedOption.includes(row)
		);
		setOptionDocument(updatedOptions);
		setOpportunityData((prevState) => ({
			...prevState,
			reviews: {
				...prevState.reviews,
				completed_list: updatedOptions, // Replace completed_list with updatedOptions
			},
		}));
		setSelectedOption([]);
	};

	const midReviewChange = (e) => {
		var curGateway = _.find(opportunityData.gateways.gateway_status, function (gate) {
			if (gate.status === "open") {
				return gate.gate;
			}
		});

		var selectedMidReview = [];
		var midRevAction = [];
		var selectedMidRevHead = e.target.value.label;

		props.reference_data.forEach((option) => {
			if (option.option_type === curGateway.gate || option.option_type === "Common") {
				if (option.display_name && option.display_name === selectedMidRevHead) {
					selectedMidReview.push(option);
				}
			}
		});

		if (selectedMidReview.length > 1) {
			selectedMidReview = _.filter(selectedMidReview, function (option) {
				if (option.option_names.indexOf(curGateway.gate, 1) !== -1) {
					return option;
				}
			});
		}

		var tmpResult = opportunityData.mid_reviews_head.filter(review =>
			review.reviews_head_name === selectedMidRevHead
		);

		if (!_.isEmpty(tmpResult)) {
			var resLength = tmpResult[0].review_check_list.length;
			if (resLength > 0) {
				for (var i = 0; i < resLength; i++) {
					midRevAction.push(tmpResult[0].review_check_list[i]);
				}
			}
		}
		setSelectedMidReview(selectedMidReview)
		setSelectedMidRevHead(selectedMidRevHead)
		setMidRevAction(midRevAction)
	}

	const deleteMrev = () => {
		var selectedId = ''
		midRevAction.forEach((action) => {
			if (action?.checked) {
				selectedId = action._id
			}
		});

		setMidRevAction(prevState =>
			prevState.filter(row => row._id !== selectedId)
		);
	}

	const addNewMrev = () => {
		if (selectedMidRevHead == 0 || selectedMidRevHead == null) {
			toastRef.current.showToast({
				type: 'error',
				message: "Select Mid-Bid Review"
			});
		} else {
			const newRow = {
				// _id: generateRandomID(),
				check_list: "",
				lesson_learned: "",
				recommended_actions: "",
				action_for: "",
				date: "",
				is_completed: false
			};
			setMidRevAction(prevState => ([
				...prevState,
				newRow
			]));
		}
	}

	const selectedElement = (index, e) => {
		setMidRevAction(prevState =>
			prevState.map((item, i) =>
				i === index ? { ...item, checked: e } : item
			)
		);
	};

	const handleChangeCheck = (index, value) => {
		setMidRevAction(prevState =>
			prevState.map((item, i) =>
				i === index ? { ...item, check_list: value.label } : item
			)
		);
	}

	const onTextLesson = (index, value) => {
		setMidRevAction(prevState =>
			prevState.map((item, i) =>
				i === index ? { ...item, lesson_learned: value } : item
			)
		);
	}

	const handleChange = (index, value) => {
		setMidRevAction(prevState =>
			prevState.map((item, i) =>
				i === index ? { ...item, recommended_actions: value.label } : item
			)
		);
	};

	const handleChangeAction = (index, value) => {
		setMidRevAction(prevState =>
			prevState.map((item, i) =>
				i === index ? { ...item, action_for: value.user_id } : item
			)
		);
	};

	const handleDate = (index, e) => {
		setMidRevAction(prevState =>
			prevState.map((item, i) =>
				i === index ? { ...item, date: Moment(e.value).format("DD-MM-YYYY") } : item
			)
		);
	};

	const reviewMidCompleted = (index, rDetails, rCategory, e) => {
		const updatedRevAction = [...midRevAction];
		updatedRevAction[index] = {
			...updatedRevAction[index],
			is_completed: e.target.checked,
		};
		setMidRevAction(updatedRevAction);

		var headFlag = false

		if (rCategory.check_list) {
			headFlag = true;
		} else {
			headFlag = false;
		}
		setrheadFlag(headFlag)
		if (e.checked == true) {
			var reviewData = {};
			var tmpCategory = (typeof (rCategory?.check_list) === 'string') ? rCategory?.check_list : rCategory?.check_list?.label;
			var isCompleted = midRevAction[index].is_completed;
			reviewData = {
				index: index,
				check_list: tmpCategory,
				review_head_name: selectedRevHead,
				is_completed: isCompleted,
			};
			setReviewData(reviewData)
			if (midRevAction[index]._id != undefined) {
				if (midRevAction[index].action_for === userId) {
					setIsUserActionOwnerSameReview(true);
					setMidReviewManagementCompletedModal(true)
				} else {
					setIsUserActionOwnerSameReview(false);
					setMidReviewManagementCompletedModal(true)
				}
			} else {
				toastRef.current.showToast({
					type: 'error',
					message: "Please save the task"
				});
				setCompletedMidState(true)
			}
		}
	}

	const reviewChange = (e) => {
		var curGateway = _.find(opportunityData.gateways.gateway_status, function (gate) {
			if (gate.status === "open") {
				return gate.gate;
			}
		});
		var selectedReview = [];
		var revAction = [];
		var selectedRevHead = e.target.value.label;
		props.reference_data.forEach((option) => {
			if (option.option_type === curGateway.gate || option.option_type === "Common") {
				if (option.display_name && option.display_name === selectedRevHead) {
					selectedReview.push(option);
				}
			}
		});
		if (selectedReview.length > 1) {
			selectedReview = _.filter(selectedReview, function (option) {
				if (option.option_names.indexOf(curGateway.gate, 1) === -1) {
					return option;
				} else if (option.option_names.indexOf(curGateway.gate, 1) > 3) {
					return option;
				}
			});
		}

		var tmpResult = opportunityData.reviews_head.filter(review =>
			review.reviews_head_name === selectedRevHead
		);

		if (!_.isEmpty(tmpResult)) {
			var resLength = tmpResult[0].review_check_list.length;
			if (resLength > 0) {
				for (var i = 0; i < resLength; i++) {
					revAction.push(tmpResult[0].review_check_list[i]);
				}
			}
		}
		setSelectedReview(selectedReview)
		setSelectedRevHead(selectedRevHead)
		setRevAction(revAction)
	}

	const removeSelected = () => {
		var selectedId = ''
		revAction.forEach((action) => {
			if (action?.checked) {
				selectedId = action._id
			}
		});

		setRevAction(prevState =>
			prevState.filter(row => row._id !== selectedId)
		);
	}

	const addNew = () => {
		if (selectedRevHead == 0 || selectedRevHead == null) {
			toastRef.current.showToast({
				type: 'error',
				message: "Select Review"
			});
		} else {
			const newRow = {
				// _id: generateRandomID(),
				check_list: "",
				lesson_learned: "",
				recommended_actions: "",
				action_for: "",
				date: "",
				is_completed: false
			};
			setRevAction(prevState => ([
				...prevState,
				newRow
			]));
		}
	}

	const selectedReviewElement = (index, e) => {
		setRevAction(prevState =>
			prevState.map((item, i) =>
				i === index ? { ...item, checked: e } : item
			)
		);
	};

	const handleChangeReviewCheck = (index, value) => {
		setRevAction(prevState =>
			prevState.map((item, i) =>
				i === index ? { ...item, check_list: value.label } : item
			)
		);
	}

	const onTextReviewLesson = (index, value) => {
		setRevAction(prevState =>
			prevState.map((item, i) =>
				i === index ? { ...item, lesson_learned: value } : item
			)
		);
	}

	const handleReviewChange = (index, value) => {
		setRevAction(prevState =>
			prevState.map((item, i) =>
				i === index ? { ...item, recommended_actions: value.label } : item
			)
		);
	};

	const handleChangeReviewAction = (index, value) => {
		setRevAction(prevState =>
			prevState.map((item, i) =>
				i === index ? { ...item, action_for: value.user_id } : item
			)
		);
	};

	const formatDate = (dateStr) => {
		if (dateStr != '' && dateStr != undefined) {
			const [day, month, year] = dateStr?.split('-').map(Number);
			return new Date(year, month - 1, day);
		}
	};

	const handleReviewDate = (index, e) => {
		setRevAction(prevState =>
			prevState.map((item, i) =>
				i === index ? { ...item, date: Moment(e.value).format("DD-MM-YYYY") } : item
			)
		);
	};

	const reviewCompleted = (index, rDetails, rCategory, e) => {
		setRevAction((prevState) => {
			const updatedRevAction = [...prevState];

			updatedRevAction[index] = {
				...updatedRevAction[index],
				is_completed: e.checked
			};

			return updatedRevAction;
		});

		var headFlag = false

		if (rCategory.check_list) {
			headFlag = true;
		} else {
			headFlag = false;
		}
		setrheadFlag(headFlag)
		if (e.checked == true) {
			var reviewData = {};
			var tmpCategory = (typeof (rCategory?.check_list) === 'string') ? rCategory?.check_list : rCategory?.check_list?.label;
			var isCompleted = revAction[index].is_completed;
			reviewData = {
				index: index,
				check_list: tmpCategory,
				review_head_name: selectedRevHead,
				is_completed: isCompleted,
			};
			setReviewData(reviewData)
			if (revAction[index]._id != undefined) {
				if (revAction[index].action_for === userId) {
					setIsUserActionOwnerSameReview(true);
					setReviewManagementCompletedModal(true)
				} else {
					setIsUserActionOwnerSameReview(false);
					setReviewManagementCompletedModal(true)
				}
			} else {
				toastRef.current.showToast({
					type: 'error',
					message: "Please save the task"
				});
				setCompletedState(true)
			}
		}
	}

	const headerTemplate = () => {
		if (rheadFlag) {
			return 'Review Head : ' + selectedRevHead + ' - ' + reviewData.check_list
		} else {
			return 'Review Head : ' + selectedRevHead
		}
	}

	// const modalReviewCompleted = async () => {
	// 	var index = reviewData.index;
	// 	var tmpReviewData = _.cloneDeep(revAction[index]);

	// 	var reviewAction = await reviewActionComplete(opportunityData._id, curCustomer, index, tmpReviewData, selectedRevHead, "reviews")
	// 	if (reviewAction.data.success) {
	// 		var clearCompNotify = await clearCompletedNotification(tmpReviewData._id)
	// 		if (clearCompNotify.data) {
	// 			if (clearCompNotify.data.status) {
	// 				socket.emit('pushNotifications', curCustomer)
	// 			}
	// 		}
	// 		setRevAction((prevState) =>
	// 			prevState.map((item, i) =>
	// 				i === index
	// 					? { ...item, is_completed: true }
	// 					: item
	// 			)
	// 		);
	// 		setReviewManagementCompletedModal(false)
	// 		toastRef.current.showToast({
	// 			type: 'success',
	// 			message: reviewAction.data.message
	// 		});
	// 	}
	// }
	const modalReviewCompleted = async () => {
		setLoading(true);

		try {
			var index = reviewData.index;
			var tmpReviewData = _.cloneDeep(revAction[index]);

			// Call the API to complete the review action
			const reviewAction = await reviewActionComplete(
				opportunityData._id,
				curCustomer,
				index,
				tmpReviewData,
				selectedRevHead,
				"reviews"
			);

			// Check if the review action was successful
			if (reviewAction && reviewAction.data && reviewAction.data.success) {
				// Clear completed notification for the review
				const clearCompNotify = await clearCompletedNotification(tmpReviewData._id);

				// Check the response for clearing the notification
				if (clearCompNotify && clearCompNotify.data && clearCompNotify.data.status) {
					socket.emit('pushNotifications', curCustomer); // Emit notification to socket
				}

				// Update the state to mark the review as completed
				setRevAction((prevState) =>
					prevState.map((item, i) =>
						i === index ? { ...item, is_completed: true } : item
					)
				);
				setReviewManagementCompletedModal(false); // Close the modal

				// Show success toast notification
				toastRef.current.showToast({
					type: 'success',
					message: reviewAction.data.message
				});
			}
		} catch (error) {
			// Handle any errors that occur during the process
			toastRef.current.showToast({
				type: 'error',
				message: "Failed to complete the review. Please try again or contact Admin."
			});
		} finally {
			setLoading(false);
		}
	};


	const closeReviewCompleted = () => {
		const index = reviewData.index;

		const updatedRevAction = [...revAction];
		updatedRevAction[index] = {
			...updatedRevAction[index],
			is_completed: false,
		};

		setRevAction(updatedRevAction);
		setReviewManagementCompletedModal(false);
	};

	const renderFooter = () => {
		return (
			<div className="cancel-footer">
				<div className="align-center justify-end pb-0">
					{
						isUserActionOwnerSameReview ?
							<>
								<ButtonElement label="No" className="cancel-new-button" onClick={() => closeReviewCompleted()} />
								<ButtonElement type="submit" label="Yes" className="save-button" onClick={() => modalReviewCompleted()} />
							</>
							:
							<ButtonElement type="submit" label="Close" className="save-button" onClick={() => closeReviewCompleted()} />
					}
				</div>
			</div>
		);
	};

	const headerMidTemplate = () => {
		if (rheadFlag) {
			return 'Review Head : ' + selectedMidRevHead + ' - ' + reviewData.check_list
		} else {
			return 'Review Head : ' + selectedMidRevHead
		}
	}

	// const modalMidReviewCompleted = async () => {
	// 	var index = reviewData.index;
	// 	var tmpReviewData = _.cloneDeep(midRevAction[index]);

	// 	var reviewAction = await midReviewActionComplete(opportunityData._id, curCustomer, index, tmpReviewData, selectedMidRevHead, "reviews")
	// 	if (reviewAction.data.success) {
	// 		setMidRevAction((prevState) =>
	// 			prevState.map((item, i) =>
	// 				i === index
	// 					? { ...item, is_completed: true }
	// 					: item
	// 			)
	// 		);
	// 		setMidReviewManagementCompletedModal(false)
	// 		toastRef.current.showToast({
	// 			type: 'success',
	// 			message: reviewAction.data.message
	// 		});
	// 	}
	// }

	const modalMidReviewCompleted = async () => {
		try {
			setLoading(true);

			const index = reviewData.index;

			const tmpReviewData = _.cloneDeep(midRevAction[index]);

			// Call API to complete the mid review action
			const reviewAction = await midReviewActionComplete(
				opportunityData._id,
				curCustomer,
				index,
				tmpReviewData,
				selectedMidRevHead,
				"reviews"
			);

			// Check if the response is successful
			if (reviewAction.data && reviewAction.data.success) {
				setMidRevAction((prevState) =>
					prevState.map((item, i) =>
						i === index ? { ...item, is_completed: true } : item
					)
				);

				toastRef.current.showToast({
					type: 'success',
					message: reviewAction.data.message
				});
			} else {
				toastRef.current.showToast({
					type: 'error',
					message: reviewAction.data?.message || "Failed to complete the review. Please try again."
				});
			}
		} catch (error) {
			// Handle errors during the API request
			toastRef.current.showToast({
				type: 'error',
				message: "An unexpected error occurred. Please try again or contact Admin."
			});
		} finally {
			setLoading(false);
			setMidReviewManagementCompletedModal(false);
		}
	};


	const closeMidReviewCompleted = () => {
		const index = reviewData.index;

		const updatedRevAction = [...midRevAction];
		updatedRevAction[index] = {
			...updatedRevAction[index],
			is_completed: false,
		};

		setMidRevAction(updatedRevAction);
		setMidReviewManagementCompletedModal(false);
	};

	const renderMidFooter = () => {
		return (
			<div className="cancel-footer">
				<div className="align-center justify-end pb-0">
					{
						isUserActionOwnerSameReview ?
							<>
								<ButtonElement label="No" className="cancel-new-button" onClick={() => closeMidReviewCompleted()} />
								<ButtonElement type="submit" label="Yes" className="save-button" onClick={() => modalMidReviewCompleted()} />
							</>
							:
							<ButtonElement type="submit" label="Close" className="save-button" onClick={() => closeMidReviewCompleted()} />
					}
				</div>
			</div>
		);
	};

	const stageTemplate = (rowData, index) => {
		if (rowData.substage == 'Target') {
			return winWorkStage.length > 0 && winWorkStage[0].length > 0 ? winWorkStage[0][0].text : props.opportunityData.winwork_stage
		} else if (rowData.substage == "Pursuit") {
			return winWorkStage.length > 0 && winWorkStage[0].length > 0 ? winWorkStage[0][1].text : props.opportunityData.winwork_stage
		} else if (rowData.substage == "Pre-Qualify") {
			return winWorkStage.length > 0 && winWorkStage[0].length > 0 ? winWorkStage[0][2].text : props.opportunityData.winwork_stage
		} else if (rowData.substage == "Submission") {
			return winWorkStage.length > 0 && winWorkStage[0].length > 0 ? winWorkStage[0][3].text : props.opportunityData.winwork_stage
		} else if (rowData.substage == "Appointment") {
			return winWorkStage.length > 0 && winWorkStage[0].length > 0 ? winWorkStage[0][4].text : props.opportunityData.winwork_stage
		} else if (rowData.substage == "Deliver") {
			return winWorkStage.length > 0 && winWorkStage[0].length > 0 ? winWorkStage[0][5].text : props.opportunityData.winwork_stage
		} else if (rowData.substage == "Feedback") {
			return winWorkStage.length > 0 && winWorkStage[0].length > 0 ? winWorkStage[0][6].text : props.opportunityData.winwork_stage
		}
	}

	const parseDateString = (dateString) => {
		if (dateString != '' && dateString != undefined) {
			const [day, month, year] = dateString.split('-')?.map(Number);
			return new Date(year, month - 1, day);
		}
	};

	const handleDueDate = (e, index) => {
		const updatedArrayData = { ...opportunityData };
		updatedArrayData.approvals[index].due_date = Moment(e.target.value).format("DD-MM-YYYY");
		setOpportunityData(updatedArrayData);
	}

	const dueDateTemplate = (rowData, index) => {
		if (reviewAccess && !rowData.approved) {
			return (
				<CalendarElement
					id="due_date"
					placeholder="Choose a date"
					value={parseDateString(rowData.due_date)}
					onChange={(e) => handleDueDate(e, index.rowIndex)}
					readOnlyInput
				/>
			)
		} else if ((rowData.approved && !reviewAccess) || (rowData.approved && reviewAccess)) {
			return rowData.due_date
		}
	}

	const findWithAttr = (attr, value) => {
		for (var i = 0; i < props.winstages.length; i += 1) {
			if (props.winstages[i][attr] === value) {
				return i;
			}
		}
	};

	const closeGate = (by) => {
		if ((by == "user" && gateClosePrivilege) || by == "auto") {
			//updating last obj
			var prevOpportunityData = opportunityData
			var lastObj = prevOpportunityData.gateways.gateway_status.pop();
			if (by == "user") {
				var closed_opportunity = {};
				for (var i = 0; i < individualScore.length; i++) {
					if (individualScore[i] != undefined) {
						if (prevOpportunityData.opportunity_type == individualScore[i].text) {
							closed_opportunity["purpose_connectivity"] = individualScore[i];
						}
						if (prevOpportunityData.project_margin == individualScore[i].text) {
							closed_opportunity["value_creation"] = individualScore[i];
						}
						if (prevOpportunityData.additional.resourcing_bid == individualScore[i].text) {
							closed_opportunity["risk"] = individualScore[i];
						}
						if (prevOpportunityData.additional.resourcing_project == individualScore[i].text) {
							closed_opportunity["geographic_impact"] = individualScore[i];
						}
						if (prevOpportunityData.additional.no_of_competitors == individualScore[i].text) {
							closed_opportunity["value_chain_partners"] = individualScore[i];
						}
						if (prevOpportunityData.additional.bond_requirement == individualScore[i].text) {
							closed_opportunity["investor_shareholder_value"] = individualScore[i];
						}
						if (prevOpportunityData.opportunity.client_meetings == individualScore[i].text) {
							closed_opportunity["depth_of_stakeholder_engagement"] = individualScore[i];
						}
					}
				}

				var newObj = {
					gate: lastObj.gate,
					role: role,
					closed_by: tmpData.username,
					status: "closed",
					closed_date: Moment().format('DD-MM-YYYY'),
					closed_time: Moment().format('HH:mm'),
					win_score: prevOpportunityData.win_score,
					closed_opportunities: closed_opportunity,
				};
				prevOpportunityData.gateways.gateway_status.push(newObj);
				// setOpportunityData(prevOpportunityData)
			} else {

				var newObj = {
					gate: lastObj.gate,
					role: "Auto",
					closed_by: "Auto",
					status: "closed",
					closed_date: Moment().format('DD-MM-YYYY'),
					closed_time: Moment().format('HH:mm'),
					win_score: prevOpportunityData.win_score,
				};
				prevOpportunityData.gateways.gateway_status.push(newObj);
				// setOpportunityData(prevOpportunityData)
			}

			var tmpStage = ''
			var nextIndex = findWithAttr("stage", lastObj.gate);
			if (lastObj.gate != "Feedback") {
				prevOpportunityData.gateways.gateway_status.push({
					gate: props.winstages[nextIndex + 1].stage,
					status: "open",
				});
				tmpStage = prevOpportunityData.winwork_stage;
				prevOpportunityData.winwork_stage = props.winstages[nextIndex + 1].stage;
			} else {
				tmpStage = prevOpportunityData.winwork_stage;
			}

			if (lastObj.gate.toLowerCase() === "submission") {
				var midGateActDate = "act_" + lastObj.gate.toLowerCase() + "_mid_phase_gateway_approval";
				var midGateEstDate = "est_" + lastObj.gate.toLowerCase() + "_mid_phase_gateway_approval";
				prevOpportunityData.gateways[midGateActDate].checked = true;
				prevOpportunityData.gateways[midGateActDate].value = "Act";
				prevOpportunityData.gateways[midGateActDate].text = Moment().format("DD-MM-YYYY");
				prevOpportunityData.gateways[midGateEstDate].checked = false;
			} else if (lastObj.gate.toLowerCase() === "deliver") {
				var midGateActDate = "act_" + lastObj.gate.toLowerCase() + "_mid_phase_approval";
				var midGateEstDate = "est_" + lastObj.gate.toLowerCase() + "_mid_phase_approval";
				prevOpportunityData.gateways[midGateActDate].checked = true;
				prevOpportunityData.gateways[midGateActDate].value = "Act";
				prevOpportunityData.gateways[midGateActDate].text = Moment().format("DD-MM-YYYY");
				prevOpportunityData.gateways[midGateEstDate].checked = false;
			} else if (lastObj.gate.toLowerCase() === "pre-qualify") {
				var midGateActDate = "act_pre_qualify_gateway_approval";
				var midGateEstDate = "est_pre_qualify_gateway_approval";
				prevOpportunityData.gateways[midGateActDate].checked = true;
				prevOpportunityData.gateways[midGateActDate].value = "Act";
				prevOpportunityData.gateways[midGateActDate].text = Moment().format("DD-MM-YYYY");
				prevOpportunityData.gateways[midGateEstDate].checked = false;
			}

			var currentGateActDate = "act_" + lastObj.gate.toLowerCase() + "_gateway_approval";
			var currentGateEstDate = "est_" + lastObj.gate.toLowerCase() + "_gateway_approval";
			if (prevOpportunityData.gateways[currentGateActDate]) {
				prevOpportunityData.gateways[currentGateActDate].checked = true;
				prevOpportunityData.gateways[currentGateActDate].value = "Act";
				prevOpportunityData.gateways[currentGateActDate].text = Moment().format("DD-MM-YYYY");
			}

			if (prevOpportunityData.gateways[currentGateEstDate]) {
				prevOpportunityData.gateways[currentGateEstDate].checked = false;
			}

			//updating opp
			var currStage = prevOpportunityData.winwork_stage;
			//Auto approval of Action items
			var prevApprovals = approvals
			for (var i = 0; i < prevApprovals.length; i++) {
				if (prevApprovals[i].approved != true) {
					prevApprovals[i].approved = true;
					prevApprovals[i].approved_date = Moment().format('DD-MM-YYYY');
					prevApprovals[i].approved_time = Moment().format('HH:mm');
					prevApprovals[i].approved_by = "Auto";
					prevApprovals[i].due_date = prevOpportunityData.due_date;
				}
			}
			setApprovals(prevApprovals)
			setGlobalOpportunityData((prevState) => ({
				...prevState,
				approvals: prevApprovals,
				gateways: prevOpportunityData.gateways,
				winwork_stage: prevOpportunityData.winwork_stage
			}))
			// props.saveOpp()
			toastRef.current.showToast({
				type: 'success',
				message: "Gateway Closed"
			});
		} else {
			toastRef.current.showToast({
				type: 'error',
				message: "Permission Denied"
			});
		}
		setLoading(false)
	};

	const saveApprovals = (reviewObj) => {
		setLoading(true)
		var everySingle = true;
		var prevApprovals = approvals
		for (var i = 0; i < prevApprovals.length; i++) {
			if (prevApprovals[i].item_id == reviewObj.item_id && prevApprovals[i].substage == reviewObj.substage) {
				prevApprovals[i].approved = true;
				prevApprovals[i].approved_date = Moment().format('DD/MM/YY');
				prevApprovals[i].approved_time = Moment().format('HH:mm');
				prevApprovals[i].approved_by_id = userId;
				prevApprovals[i].approved_by = tmpData.username;
				prevApprovals[i].due_date = reviewObj.due_date;
				if (prevApprovals[i].approved == false || prevApprovals[i].approved == undefined) {
					everySingle = false;
				}
			} else if (prevApprovals[i].approved == false || prevApprovals[i].approved == undefined) {
				everySingle = false;
			}
		}
		setApprovals(prevApprovals)

		var prevOpp = opportunityData
		setOpportunityData((prevState) => ({
			...prevState,
			approvals: prevApprovals
		}))
		prevOpp.approvals = prevApprovals;

		if (everySingle == true) {
			closeGate("auto");
			reviewLoad(prevOpp);
		} else {
			setGlobalOpportunityData((prevData) => ({
				...prevData,
				approvals: prevApprovals
			}));
			setLoading(false)
		}
	}

	const approveTemplate = (rowData) => {
		if (reviewAccess) {
			if (rowData.approved == undefined && rowData.isRACI == true || rowData.approved == false && rowData.isRACI == true) {
				return (
					<ButtonElement type='button' label="Approve" className="approve-button" onClick={() => saveApprovals(rowData)} />
				)
			} else if (rowData.isRACI == false && (rowData.approved == undefined || rowData.approved == false)) {
				return <span>Pending</span>
			} else if (rowData.approved == true) {
				return <span>{rowData.approved_by}</span>
			}
		} else if (!reviewAccess) {
			if (rowData.approved == undefined || rowData.approved == false) {
				return <span>Pending</span>
			} else if (rowData.approved == true) {
				return <span>{rowData.approved_by}</span>
			}
		}
	}

	const columns4 = [
		{ field: "winwork_display", header: _.find(props.fieldData.oppReviewsApprovalHeaders, { header_name: "Substage" })?.display_name, body: stageTemplate, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '15%' } },
		{ field: "role", header: _.find(props.fieldData.oppReviewsApprovalHeaders, { header_name: "Role" })?.display_name, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '20%' } },
		{ field: "item", header: _.find(props.fieldData.oppReviewsApprovalHeaders, { header_name: "Item" })?.display_name, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '25%' } },
		{ field: "due_date", header: _.find(props.fieldData.oppReviewsApprovalHeaders, { header_name: "Due Date" })?.display_name, body: dueDateTemplate, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '15%' } },
		{ field: "approved_date", header: _.find(props.fieldData.oppReviewsApprovalHeaders, { header_name: "Approval Date" })?.display_name, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '15%' } },
		{ field: "approved_time", header: _.find(props.fieldData.oppReviewsApprovalHeaders, { header_name: "Time" })?.display_name, headerClassName: "header-datatable", className: 'row-datatable', style: { width: '15%' } },
		{ field: "approved", header: _.find(props.fieldData.oppReviewsApprovalHeaders, { header_name: "Approved" })?.display_name, body: approveTemplate, headerClassName: "header-datatable", className: 'row-datatable' }
	]


	const handleButtonClick = () => {
		setShowVideo(true);
	};

	const closeVideo = () => {
		setShowVideo(false);
	};

	return (
		<div>
			<ToastElement ref={toastRef} />
			<Loader loading={loading} />
			<div className="col-md-12 text-right">
				<ButtonElement className="upload-button" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
			</div>
			{
				<form className='grid-display'>
					{
						Object.entries(newModule)?.map(([key, value]) => (
							<div key={key} className='mt-10'>
								<Accordion activeIndex={0}>
									{
										<AccordionTab header={key == 'obj2' ? value + ' ' + tooltipElem : value} disabled>
											{
												key == 'obj1' &&
												<div className='new-field'>
													<DataTable
														value={filteredApprovals.length > 0 ? filteredApprovals : []}
														columns={columns4}
														dataKey="_id"
														isNewField={true}
													/>
												</div>
											}
											{
												key == 'obj2' &&
												<>
													{
														props.midStage &&
														<div className="new-field">
															{
																_.find(props.fieldData.oppReviewsTable, { table_name: "Review Actions" })?.status &&
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className='col-md-4 pl-0'>
																		<SingleSelectElement
																			onChangeValue={(e) => midReviewChange(e)}
																			id="selectedMidReviewHead"
																			options={(bidReviewHead != undefined && bidReviewHead.length > 0 && props.midStageIndex != undefined) ? bidReviewHead[props.midStageIndex] : []}
																			optionLabel="label"
																			placeholder="-- Please select --"
																			className="w-full"
																			maxSelectedLabels={1}
																		/>
																	</div>
																	<div className="form-group row align-items-center mb-0">
																		<div className="col-md-4 pl-0">
																			<label className="form-label text-left font-bold">{_.find(props.fieldData.oppReviewsTable, { table_name: "Review Actions" })?.display_name}</label>
																		</div>
																		<div className="col pr-0 d-flex justify-end delete-icon">
																			<ButtonElement type="button" className="edit-option-button" icon="pi pi-trash" onClick={deleteMrev} />
																			<ButtonElement type="button" className="edit-option-button ml-10" icon="pi pi-plus" onClick={addNewMrev} />
																		</div>
																	</div>
																	<div className="group-table-data pl-0 risks-tab">
																		<table className="group-datatable">
																			<thead className="group-table-header">
																				<tr>
																					<th className="checkbox-header"></th>
																					<th className="w-20">{_.find(props.fieldData.oppReviewsActionHeaders, { header_name: 'Reviews' })?.display_name}</th>
																					<th className="w-20">{_.find(props.fieldData.oppReviewsActionHeaders, { header_name: 'Lesson Learned' })?.display_name}</th>
																					<th className="w-20">{_.find(props.fieldData.oppReviewsActionHeaders, { header_name: 'Recommended Actions' })?.display_name}</th>
																					<th className="w-20">{_.find(props.fieldData.oppReviewsActionHeaders, { header_name: 'Action for' })?.display_name}</th>
																					<th className="w-20">{_.find(props.fieldData.oppReviewsActionHeaders, { header_name: 'Date' })?.display_name}</th>
																					<th className="w-20">{_.find(props.fieldData.oppReviewsActionHeaders, { header_name: 'Completed' })?.display_name}</th>
																				</tr>
																			</thead>
																			<tbody className="group-table-row stakeplan">
																				{
																					midRevAction.length > 0 && midRevAction?.map((item, index) => {
																						const checkList = item.check_list;

																						const matched = selectedMidReview[0]?.option_choice.find(
																							(item) => item.label === checkList
																						);

																						const recommendations = item.recommended_actions;

																						const matched_recommend = midRecommendedActions.length > 0 && props.midStageIndex != undefined ? midRecommendedActions[props.midStageIndex].find(
																							(item) => item.label === recommendations
																						) : '';

																						const action = item.action_for;

																						const matched_action = props.opportunityData.ie_bid_team.internal_bid_team.find(
																							(item) => item.user_id === action
																						);
																						return (
																							<React.Fragment>
																								<tr>
																									<td>
																										<CheckboxElement
																											id={`review-${index}`}
																											name={`review-${index}`}
																											checked={item.checked}
																											onChangeCheck={(e) => { selectedElement(index, e.target.checked) }}
																											className="mr-2"
																										/>
																									</td>
																									<td className="w-20">
																										<DropdownElement
																											onChange={(e) => handleChangeCheck(index, e.target.value)}
																											id="check_list"
																											options={(selectedMidReview != undefined && selectedMidReview.length > 0) ? selectedMidReview[0].option_choice : []}
																											optionLabel="label"
																											placeholder="-- Please select --"
																											className="w-150"
																											maxSelectedLabels={1}
																											value={matched ? matched : null}
																										/>
																									</td>
																									<td className="w-20">
																										<InputTextElementElement
																											className="dropdown-field-handle"
																											value={item.lesson_learned}
																											placeholder="Description"
																											onChange={(e) => onTextLesson(index, e.target.value)}
																										/>
																									</td>
																									<td className="w-20">
																										<DropdownElement
																											onChange={(e) => handleChange(index, e.target.value)}
																											id="recommended_actions"
																											options={(midRecommendedActions != undefined && midRecommendedActions.length > 0 && props.midStageIndex != undefined) ? midRecommendedActions[props.midStageIndex] : []}
																											optionLabel="label"
																											placeholder="-- Please select --"
																											className="w-150"
																											maxSelectedLabels={1}
																											value={matched_recommend ? matched_recommend : null}
																										/>
																									</td>
																									<td className="w-20">
																										<DropdownElement
																											onChange={(e) => handleChangeAction(index, e.target.value)}
																											id="action_for"
																											options={(props.opportunityData?.ie_bid_team?.internal_bid_team != undefined && props.opportunityData?.ie_bid_team?.internal_bid_team.length > 0) ? props.opportunityData?.ie_bid_team?.internal_bid_team : []}
																											optionLabel="team_member"
																											placeholder="-- Please select --"
																											className="w-150"
																											maxSelectedLabels={1}
																											value={matched_action ? matched_action : null}
																										/>
																									</td>
																									<td className="w-20">
																										<CalendarElement
																											id="date"
																											placeholder="Choose a date"
																											value={formatDate(item.date)}
																											onChange={(e) => handleDate(index, e)}
																											readOnlyInput
																										/>
																									</td>
																									<td className="w-20">
																										<CheckboxElement
																											id={`complete-${index}`}
																											name={`complete-${index}`}
																											checked={item.is_completed}
																											onChangeCheck={(e) => { reviewMidCompleted(index, midRevAction, item, e) }}
																											className="mr-2"
																										/>
																									</td>
																								</tr>
																							</React.Fragment>
																						);
																					})
																				}
																			</tbody>
																		</table>
																	</div>
																</div>
															}
														</div>
													}
													{
														<div className="new-field">
															{
																_.find(props.fieldData.oppReviewsTable, { table_name: "Review Actions" })?.status &&
																<div className="form-group row align-items-center mb-0 mt-0">
																	<div className='col-md-4 pl-0'>
																		<SingleSelectElement
																			onChangeValue={(e) => reviewChange(e)}
																			id="selectedReviewHead"
																			options={(reviewHead != undefined && reviewHead.length > 0 && props.stageIndex != undefined) ? reviewHead[props.stageIndex] : []}
																			optionLabel="label"
																			placeholder="-- Please select --"
																			className="w-full"
																			maxSelectedLabels={1}
																		/>
																	</div>
																	<div className="form-group row align-items-center mb-0">
																		<div className="col-md-4 pl-0">
																			<label className="form-label text-left font-bold">{_.find(props.fieldData.oppReviewsTable, { table_name: "Review Actions" })?.display_name}</label>
																		</div>
																		<div className="col pr-0 d-flex justify-end delete-icon">
																			<ButtonElement type="button" className="edit-option-button" icon="pi pi-trash" onClick={removeSelected} />
																			<ButtonElement type="button" className="edit-option-button ml-10" icon="pi pi-plus" onClick={addNew} />
																		</div>
																	</div>
																	<div className="group-table-data pl-0 risks-tab">
																		<table className="group-datatable">
																			<thead className="group-table-header">
																				<tr>
																					<th className="checkbox-header"></th>
																					<th className="w-20">{_.find(props.fieldData.oppReviewsActionHeaders, { header_name: 'Reviews' })?.display_name}</th>
																					<th className="w-20">{_.find(props.fieldData.oppReviewsActionHeaders, { header_name: 'Lesson Learned' })?.display_name}</th>
																					<th className="w-20">{_.find(props.fieldData.oppReviewsActionHeaders, { header_name: 'Recommended Actions' })?.display_name}</th>
																					<th className="w-20">{_.find(props.fieldData.oppReviewsActionHeaders, { header_name: 'Action for' })?.display_name}</th>
																					<th className="w-20">{_.find(props.fieldData.oppReviewsActionHeaders, { header_name: 'Date' })?.display_name}</th>
																					<th className="w-20">{_.find(props.fieldData.oppReviewsActionHeaders, { header_name: 'Completed' })?.display_name}</th>
																				</tr>
																			</thead>
																			<tbody className="group-table-row stakeplan">
																				{
																					revAction.length > 0 && revAction?.map((item, index) => {
																						const checkList = item.check_list;

																						const matched = selectedReview[0]?.option_choice.find(
																							(item) => item.label === checkList
																						);

																						const recommendations = item.recommended_actions;

																						const matched_recommend = props.stageIndex != undefined ? recommendedActions[props.stageIndex]?.find(
																							(item) => item.label === recommendations
																						) : '';

																						const action = item.action_for;

																						const matched_action = props.opportunityData.ie_bid_team.internal_bid_team.find(
																							(item) => item.user_id === action
																						);
																						return (
																							<React.Fragment>
																								<tr>
																									<td>
																										<CheckboxElement
																											id={`rev-${index}`}
																											name={`rev-${index}`}
																											checked={item.checked}
																											onChangeCheck={(e) => { selectedReviewElement(index, e.target.checked) }}
																											className="mr-2"
																										/>
																									</td>
																									<td className="w-20">
																										<DropdownElement
																											onChange={(e) => handleChangeReviewCheck(index, e.target.value)}
																											id="check_list"
																											options={(selectedReview != undefined && selectedReview.length > 0) ? selectedReview[0].option_choice : []}
																											optionLabel="label"
																											placeholder="-- Please select --"
																											className="w-150"
																											maxSelectedLabels={1}
																											value={matched ? matched : null}
																										/>
																									</td>
																									<td className="w-20">
																										<InputTextElementElement
																											className="dropdown-field-handle"
																											value={item.lesson_learned}
																											placeholder="Description"
																											onChange={(e) => onTextReviewLesson(index, e.target.value)}
																										/>
																									</td>
																									<td className="w-20">
																										<DropdownElement
																											onChange={(e) => handleReviewChange(index, e.target.value)}
																											id="recommended_actions"
																											options={(recommendedActions != undefined && recommendedActions.length > 0 && props?.stageIndex != undefined) ? recommendedActions[props?.stageIndex] : []}
																											optionLabel="label"
																											placeholder="-- Please select --"
																											className="w-150"
																											maxSelectedLabels={1}
																											value={matched_recommend ? matched_recommend : null}
																										/>
																									</td>
																									<td className="w-20">
																										<DropdownElement
																											onChange={(e) => handleChangeReviewAction(index, e.target.value)}
																											id="action_for"
																											options={(props.opportunityData?.ie_bid_team?.internal_bid_team != undefined && props.opportunityData?.ie_bid_team?.internal_bid_team.length > 0) ? props.opportunityData?.ie_bid_team?.internal_bid_team : []}
																											optionLabel="team_member"
																											placeholder="-- Please select --"
																											className="w-150"
																											maxSelectedLabels={1}
																											value={matched_action ? matched_action : null}
																										/>
																									</td>
																									<td className="w-20">
																										<CalendarElement
																											id="date"
																											placeholder="Choose a date"
																											value={formatDate(item.date)}
																											onChange={(e) => handleReviewDate(index, e)}
																											readOnlyInput
																											className='w-full'
																										/>
																									</td>
																									<td className="w-20">
																										<CheckboxElement
																											id={`completed-${index}`}
																											name={`completed-${index}`}
																											checked={item.is_completed}
																											onChangeCheck={(e) => { reviewCompleted(index, revAction, item, e) }}
																											className="mr-2"
																										/>
																									</td>
																								</tr>
																							</React.Fragment>
																						);
																					})
																				}
																			</tbody>
																		</table>
																	</div>
																</div>
															}
														</div>
													}
												</>
											}
											{
												key == 'obj3' &&
												<div className="new-field">
													{
														_.find(props.fieldData.oppReviewsTable, { table_name: "Positioning to win checklist for the current stages" })?.status &&
														<div className="form-group row mb-0 mt-0 box-border-plan">
															<div className="col pr-0">
																<DataTable
																	value={reviewChklist.length > 0 ? reviewChklist : []}
																	columns={columns1}
																	dataKey="_id"
																	isNewField={true}
																/>
															</div>
														</div>
													}
												</div>
											}
											{
												key == 'obj4' &&
												<div className="new-field">
													{
														_.find(props.fieldData.oppReviewsTable, { table_name: "My Responsibilities" })?.status &&
														<div className="form-group row mb-0 mt-0 box-border-plan">
															<div className="col pr-0">
																<DataTable
																	value={reviewTools.length > 0 ? reviewTools : []}
																	columns={columns2}
																	dataKey="_id"
																	isNewField={true}
																/>
															</div>
														</div>
													}
												</div>
											}
											{
												key == 'obj5' &&
												<div className="new-field">
													{
														_.find(props.fieldData.oppReviewsTable, { table_name: "Review Prompts" })?.status &&
														<div className="form-group row mb-0 mt-0 box-border-plan">
															<div className="col pr-0">
																<DataTable
																	value={reviewTools.length > 0 ? reviewTools : []}
																	columns={columns3}
																	dataKey="_id"
																	isNewField={true}
																/>
															</div>
														</div>
													}
												</div>
											}
											{
												key == 'obj6' &&
												<div className="new-field">
													{
														_.find(props.fieldData.oppReviewsTable, { table_name: "Completed List" })?.status &&
														<div className="form-group row mb-0 mt-0 box-border-plan">
															<div className="col pr-0">
																<div className="form-group row align-items-center mb-0">
																	<div className="col-md-6 pl-0">
																		<p className="label-text">
																			{_.find(props.fieldData.oppReviewsTable, { table_name: "Completed List" })?.display_name}
																		</p>
																	</div>
																	<div className="col pr-0 d-flex justify-end">
																		<ButtonElement className="edit-option-button" type="button" icon="pi pi-trash" onClick={handleDeleteDocument} />
																		<ButtonElement className="edit-option-button ml-10" type="button" icon="pi pi-plus" onClick={addItemDocument} />
																	</div>
																</div>
																<DataTable
																	value={opportunityData.reviews?.completed_list.length > 0 ? opportunityData.reviews?.completed_list : []}
																	columns={columns}
																	dataKey="_id"
																	isNotReorder={true}
																	rowClick={rowClick}
																/>
															</div>
														</div>
													}
												</div>
											}
										</AccordionTab>
									}
								</Accordion>
							</div>
						)
						)
					}
				</form>
			}
			<Dialog
				header={headerTemplate}
				visible={reviewManagementCompletedModal}
				position="right"
				onHide={() => closeReviewCompleted()}
				draggable={false}
				resizable={false}
				footer={renderFooter()}
				className="table-dialog width-32"
			>
				<>
					{
						isUserActionOwnerSameReview ? <div className="confirmation-content">
							<span className="table-description">
								Do you want to complete this action?
							</span>
						</div> :
							<div className="confirmation-content">
								<span className="table-description">
									This action belongs to another user. Your are not authorised to complete this action.
								</span>
							</div>

					}
				</>
			</Dialog>
			<Dialog
				header={headerMidTemplate}
				visible={midReviewManagementCompletedModal}
				position="right"
				onHide={() => closeMidReviewCompleted()}
				draggable={false}
				resizable={false}
				footer={renderMidFooter()}
				className="table-dialog width-32"
			>
				<>
					{
						isUserActionOwnerSameReview ? <div className="confirmation-content">
							<span className="table-description">
								Do you want to complete this action?
							</span>
						</div> :
							<div className="confirmation-content">
								<span className="table-description">
									This action belongs to another user. Your are not authorised to complete this action.
								</span>
							</div>

					}
				</>
			</Dialog>
			<Dialog id="videoModal" visible={showVideo}
				breakpoints={{
					'1200px': '80vw',    // Larger modal on bigger screens
					'1024px': '85vw',    // Slightly smaller for medium screens
					'769': '90vw',     // Responsive on tablets
					'641px': '95vw',     // Almost full-width on mobile
				}}
				modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
			>
				<div className="video-overlay">
					<div className="video-container">
						<PlaylistVideos playlistId={process.env.REACT_APP_PORTFOLIO_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="reviews" />
					</div>
				</div>
			</Dialog>
		</div>
	)
}

export default ReviewAndGovernance